import { render, staticRenderFns } from "./processDesign.vue?vue&type=template&id=2d3d5da4&scoped=true&"
import script from "./processDesign.vue?vue&type=script&lang=ts&"
export * from "./processDesign.vue?vue&type=script&lang=ts&"
import style0 from "./processDesign.vue?vue&type=style&index=0&id=2d3d5da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3d5da4",
  null
  
)

export default component.exports